module.exports = __webpack_public_path__ + "e953d8a991e4161e12cea8109b268152.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/en/stingray_qello.jpg
// module id = 861
// module chunks = 0